import { Subject } from 'rxjs'

export const UserChartChanged = new Subject<void>()
